const materialCheckboxes = document.querySelectorAll('.media-materials input');

materialCheckboxes.forEach((el) => {
  el.addEventListener('change', () => {
    const parent = el.closest('.media-materials__body');
    const button = parent.querySelector('.btn');

    button.classList.toggle('btn--disabled', !el.checked);
  });
});

// **********************************************************
// Download Files
// **********************************************************

const mediaMaterialsEl = document.querySelector('.media-materials');

if (mediaMaterialsEl) {
  // Axios download media materials
  const axiosDownloadMediaMaterials = async (parent) => {
    const { id, k, pageBuilderName } = parent.querySelector('input[name="module-data"]').dataset;
    const formDataInput = {
      action: 'downloadMediaMaterials',
      id,
      k,
      pageBuilderName,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      if (data.data.zip_url) {
        window.location.href = data.data.zip_url;
      }
    } catch (err) {
      console.error(err);
    }
  };

  attachEvent('.download-button', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.media-materials__body');
    axiosDownloadMediaMaterials(parent);
  });
}
